import { takeLatest, call, put, select } from "redux-saga/effects";
import _ from "lodash";
import * as actions from "../commentActions";
import { resolveComment, unResolveComment } from "../../../services/comments";

export default function* toggleResolveCommentWatcher() {
  yield takeLatest(actions.TOGGLE_COMMENT_RESOLVE, toggleResolveCommentWorker);
}

export function* toggleResolveCommentWorker(action) {
  const { categoryId, sequenceNumber, resolve } = action;
  const values = {
    doc_category_id: categoryId,
    comment_seq_nbr: sequenceNumber,
  };
  try {
    let response = null;
    if (resolve == true) {
      response = yield call(resolveComment, values);
    } else {
      response = yield call(unResolveComment, values);
    }
    yield call(success, response, categoryId, sequenceNumber, resolve);
  } catch (err) {
    yield call(failure, err);
  }
}

export function* success(response, categoryId, sequenceNumber, resolve) {
  const successFlag = response.data.toggleResolveCategoryComment.Success;
  if (successFlag === "true") {
    const comments = yield select(state => _.get(state, 'comments.data', []));
    const loggedInUser = yield select(state => _.get(state, 'session.user.data', {}));
    const index = _.findIndex(comments, {
      doc_category_id: categoryId,
      comment_seq_nbr: sequenceNumber,
    });
    if (index !== -1) {
      const updatedFields = {
        updated_by_name: loggedInUser.name || '',
        last_action_ts: new Date().toISOString(),
        last_action_type: resolve ? 'Resolved' : 'Unresolved',
        cmt_complete_ts: resolve ? new Date().toISOString() : null,
      };
      yield put(actions.updateComment(index, updatedFields));
    }
  } else {
    alert("Could not resolve/unresolve comment");
  }
}

export function* failure(error) {
  yield put(actions.error(error));
}
